import List from "@/components/list";
import vue from "@/main.js";

const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  const { type } = args.parent;

  function handleDelete({ row }) {
    vue.$emit("deleteSms", row);
  }

  function handleResend({ row }) {
    vue.$emit("resendSms", row);
  }

  const Deal = ({ props: { vo } }) => {
    let dealConf = [
      ["icon-delete", "删除", () => handleDelete(vo), "bizMessage:delete"]
    ];
    if (type === "failure") {
      dealConf.push([
        "icon-down",
        "再次发送",
        () => handleResend(vo),
        "bizMessage:resend"
      ]);
    }
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "短信内容",
      prop: "smsContent",
      showOverflowTooltip: true,
      minWidth: 200
    },
    {
      label: "接收人姓名",
      prop: "toUserName"
    },
    {
      label: "手机号码",
      prop: "toMobile"
    },
    {
      label: "所属单位",
      prop: "deptName"
    },
    {
      label: "单位及职务",
      prop: "unitPosition"
    },
    {
      label: "最后发送时间",
      prop: "smsSendDate"
    },
    {
      label: "操作",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
